import { createFileRoute } from "@tanstack/react-router";
import { MotionGraphicsServicePage } from "./services_.motion-graphics";

export const Route = createFileRoute("/services_/branding-creatives-and-motion-ai-video-services")({
  head: () => ({
    meta: [
      {
        title: "Motion & AI Video Services — KMWAdvertising",
      },
      {
        name: "description",
        content: "Engaging Motion Graphics & AI-Powered Video Creation.",
      },
    ],
  }),
  component: MotionGraphicsServicePage,
});
